import clsx from 'clsx';
import * as React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import StoryblokLink from '../StoryblokLink';

export default function TextWithImageSection({ blok }) {
  const parentBlock = blok;
  const styles = clsx(
    `text-with-image-section px-4 lg:px-16 ${
      parentBlock.full_height_desktop ? '' : 'pt-28'
    }`,
  );
  parentBlock.image.src = parentBlock.image.filename;
  const { image } = parentBlock;
  const sameWidth = blok.image_width === 'lg:w-1/2';

  return (
    <div
      {...storyblokEditable(blok)}
      className={styles}
      id={blok.internal_page_id || ''}
    >
      <div>
        <div
          className={`flex-col lg:flex-row flex-nowrap items-stretch gap-16 lg:flex ${
            parentBlock.inversedirection ? 'lg:flex-row-reverse' : ''
          }

          ${parentBlock.full_height_desktop ? 'lg:h-[100vh]' : ''}`}
        >
          <div
            className={`w-full ${
              sameWidth ? blok.image_width : 'lg:w-2/5'
            } flex flex-col items-start justify-center gap-0 lg:gap-0 image-with-text-element`}
          >
            {blok?.blocks.map((block) => (
              <StoryblokComponent
                blok={block}
                key={block._uid}
                extraSettings={{ removePadding: true }}
              />
            ))}

            {parentBlock.buttonlink
              && parentBlock.buttonlink.cached_url.length > 0 && (
                <StoryblokLink
                  to={parentBlock.buttonlink?.story?.full_slug || parentBlock.buttonlink.cached_url}
                  className="button-primary font-monospace font-bold uppercase text-left text-lg md:text-xl mt-4 hyphens-auto"
                  rel="nofollow"
                >
                  {parentBlock.buttontext}
                </StoryblokLink>
            )}
            {parentBlock.image && (
              <div className={`flex items-center lg:hidden justify-center order-2 w-full ${blok.image_width}`}>
                <div className="w-full">
                  <div className="w-full">
                    <div className="">
                      <img
                        src={image.src}
                        alt={parentBlock.image.alt}
                        className="w-full "
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {parentBlock.image && (
            <div className={`flex items-center hidden lg:flex justify-center order-2 w-full ${blok.image_width}`}>
              <div className="w-full">
                <div className="w-full">
                  <div className="">
                    <img
                      src={image.src}
                      alt={parentBlock.image.alt}
                      className="w-full "
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
